<script>
    import { cubeVolCalc, filterNeg } from "./helpers/calculators";
    import { Input, FormGroup } from "sveltestrap";
    import Cube from "./Shapes/Cube.svelte";

    let l;
    let b;
    let h;
    let unit = "imperial";
    let lVal, bVal, hVal;
    $: l ? ((l = filterNeg(l)), (lVal = l)) : (lVal = "l");
    $: h ? ((h = filterNeg(h)), (hVal = h)) : (hVal = "h");
    $: b ? ((b = filterNeg(b)), (bVal = b)) : (bVal = "b");
    $: v = cubeVolCalc(l, b, h, unit);
</script>

<FormGroup>
    <Input
        id="r2"
        type="radio"
        bind:group={unit}
        value="imperial"
        label="Imperial (feet/gallons)"
    />
    <Input
        id="r1"
        type="radio"
        bind:group={unit}
        value="metric"
        label="Metric (metres/litres)"
    />
</FormGroup>

<input type="number" min="0" placeholder="length" bind:value={l} />
<input type="number" min="0" placeholder="breadth" bind:value={b} />
<input type="number" min="0" placeholder="height" bind:value={h} />
<br />
<br />
<Cube l={lVal} b={bVal} h={hVal} />
<br />
<br />
<h2>Volume: {v}</h2>
<br />
<br />

<style>
    input {
        border-radius: 10px !important;
        margin-bottom: 1rem;
        width: 32%;
    }

    @media (max-width: 768px) {
        input {
            width: 100%;
        }
    }
</style>
